import axios from 'axios';
import { config } from 'Constants';

/**
 * @desc Get all emails from Gmail
 * @param {Object} params - Query parameters (page, limit, label, etc.)
 * @return promise - axios returns a promise
 */
export const getEmails = (params = {}) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails`;
    return axios.get(url, { headers, params });
};

/**
 * @desc Get a specific email by ID
 * @param {string} emailId - Gmail email ID
 * @return promise - axios returns a promise
 */
export const getEmailById = (emailId) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/${emailId}`;
    return axios.get(url, { headers });
};

/**
 * @desc Send a reply to an email
 * @param {string} emailId - Gmail email ID
 * @param {Object} data - Reply data (message, attachments, etc.)
 * @return promise - axios returns a promise
 */
export const replyToEmail = (emailId, data) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/${emailId}/reply`;
    return axios.post(url, data, { headers });
};

/**
 * @desc Mark email as read/unread
 * @param {string} emailId - Gmail email ID
 * @param {boolean} read - Read status
 * @return promise - axios returns a promise
 */
export const markEmailAsRead = (emailId, read) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/${emailId}/read`;
    return axios.put(url, { read }, { headers });
};

/**
 * @desc Get email labels
 * @return promise - axios returns a promise
 */
export const getEmailLabels = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/labels`;
    return axios.get(url, { headers });
};

/**
 * @desc Add or remove labels from email
 * @param {string} emailId - Gmail email ID
 * @param {Object} data - Label data (addLabels, removeLabels)
 * @return promise - axios returns a promise
 */
export const updateEmailLabels = (emailId, data) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/${emailId}/labels`;
    return axios.put(url, data, { headers });
};

/**
 * @desc Search emails
 * @param {Object} params - Search parameters (query, pageToken, etc.)
 * @return promise - axios returns a promise
 */
export const searchEmails = (params = {}) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/search`;
    return axios.get(url, { headers, params });
};

/**
 * @desc Get a thread of emails by threadId
 * @param {string} threadId - Gmail email thread ID
 * @return promise - axios returns a promise
 */
export const getEmailThread = (threadId) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/thread/${threadId}`;

    console.log('Fetching email thread:', threadId);

    return axios
        .get(url, { headers })
        .then((response) => {
            console.log('Email thread response:', response.data);
            return response;
        })
        .catch((error) => {
            console.error('Error fetching email thread:', error);
            throw error;
        });
};

/**
 * @desc Associate an email thread with a project or other entity
 * @param {string} threadId - Email thread ID
 * @param {string} entityId - ID of the entity to associate with (e.g., project ID)
 * @param {string} associationType - Type of association (e.g., 'project', 'lead')
 * @return promise - axios returns a promise
 */
export const associateEmailThread = (threadId, entityId, associationType) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/associate`;
    return axios.post(url, { threadId, entityId, associationType }, { headers });
};

/**
 * @desc Get a thread of emails by threadId from database with sync option
 * @param {string} threadId - Email thread ID
 * @param {boolean} skipSync - Whether to skip synchronization
 * @return promise - axios returns a promise
 */
export const getThreadFromDatabase = (threadId, skipSync = false) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/emails/db-thread/${threadId}?skipSync=${skipSync}`;

    console.log('Fetching email thread from database:', threadId, 'skipSync:', skipSync);

    return axios
        .get(url, { headers })
        .then((response) => {
            console.log('Email thread from database response:', response.data);
            return response;
        })
        .catch((error) => {
            console.error('Error fetching email thread from database:', error);
            throw error;
        });
};
